import { render as y } from "./ghl-ui.es1392.js";
import { removeElement as s, queryElement as h, createElement as E } from "./ghl-ui.es1191.js";
import q from "./ghl-ui.es951.js";
typeof window < "u" && (window.__cssrContext = {});
function g(l, e, n) {
  const { els: t } = e;
  if (n === void 0)
    t.forEach(s), e.els = [];
  else {
    const o = h(n);
    o && t.includes(o) && (s(o), e.els = t.filter((c) => c !== o));
  }
}
function a(l, e) {
  l.push(e);
}
function v(l, e, n, t, o, c, w, m, d) {
  if (c && !d) {
    if (n === void 0) {
      console.error("[css-render/mount]: `id` is required in `silent` mode.");
      return;
    }
    const f = window.__cssrContext;
    f[n] || (f[n] = !0, y(e, l, t, c));
    return;
  }
  let r;
  if (n === void 0 && (r = e.render(t), n = q(r)), d) {
    d.adapter(n, r ?? e.render(t));
    return;
  }
  const i = h(n);
  if (i !== null && !w)
    return i;
  const u = i ?? E(n);
  if (r === void 0 && (r = e.render(t)), u.textContent = r, i !== null)
    return i;
  if (m) {
    const f = document.head.querySelector(`meta[name="${m}"]`);
    if (f)
      return document.head.insertBefore(u, f), a(e.els, u), u;
  }
  return o ? document.head.insertBefore(u, document.head.querySelector("style, link")) : document.head.appendChild(u), a(e.els, u), u;
}
export {
  v as mount,
  g as unmount
};
